import React, {useState, useEffect} from 'react'
import {TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Card, CardContent} from "@mui/material"
import AddUserModal from './AddUserModal'
import ClientService from "../../../../services/ClientService";
import ClientContext from "../../../../providers/CurrentClientProvider";
import UserService from "../../../../services/UserService";

const cssInJs = {
    header: {
        backgroundColor: "#fafafa",
        color: "black",
        padding: "20px",
        display: "flex",
        justifyContent: "space-between",
        borderBottom: '1px rgba(92,63,117,0.1) solid'

    },
    headerLink: {},
}

const UserStep = () => {
    const [isAddUserModalVisible, setAddUserModalVisible] = useState(false)
    const [userData, setUserData] = useState([]);
    const client_context = ClientContext.useClient()
    const [client, setClient] = useState({})

    useEffect(async () => {
        if (!userData.length && client_context.client.Id) {
            let ud = await ClientService.getClientUsersById(client_context.client.Id)
            setUserData(ud)
        }
    }, []);
    const toggleAddUserModal = (e) => {

        if (e) {
            e.preventDefault();
        }
        setAddUserModalVisible(!isAddUserModalVisible);
    }
    const handleSaveUserData = async (data) => {
        try {
            let response = await UserService.assignUserToRole(data.user.id, data.role.id, client_context.client.Id);
            let _ud = userData.map(u => u)
            _ud.push(response)
            setUserData(_ud);
            toggleAddUserModal();
        } catch (error) {
            console.error('Error:', error);
        }
    };


    return (
        <Card>
            <div style={cssInJs.header}>
                <span>Users</span>
                <a href="#" style={cssInJs.headerLink} onClick={toggleAddUserModal}>
                    Add User
                </a>
            </div>
            <CardContent>
                <TableContainer>
                    <Table size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={4}></TableCell>
                                <TableCell colSpan={3} align="center">Monthly / Setup</TableCell>
                                <TableCell colSpan={3}></TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell align="left">Role</TableCell>
                                <TableCell align="left">Name</TableCell>
                                <TableCell align="left">Pay?</TableCell>
                                <TableCell align="left">%</TableCell>
                                <TableCell align="center">OTB</TableCell>
                                <TableCell align="center">PNOTB</TableCell>
                                <TableCell align="center">NOTB</TableCell>
                                <TableCell align="left">Shuttle</TableCell>
                                <TableCell align="left">Headcount</TableCell>
                                <TableCell align="left">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                                {userData && userData.length ? (
                                    userData.map( user => {
                                        return <TableRow>
                                            <TableCell align="left">{user.role.name || ''}</TableCell>
                                            <TableCell align="left">{user.user.email || ''}</TableCell>
                                            <TableCell align="left">{'No'}</TableCell>
                                            <TableCell align="left">{0}</TableCell>
                                            <TableCell align="left">{'0 / 0'}</TableCell>
                                            <TableCell align="left">{'0 / 0'}</TableCell>
                                            <TableCell align="left">{'0 / 0'}</TableCell>
                                            <TableCell align="left">{0}</TableCell>
                                            <TableCell align="left">{0}</TableCell>
                                        </TableRow>
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                        <TableCell align="left">No available</TableCell>
                                    </TableRow>
                                )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
            <AddUserModal open={isAddUserModalVisible} onClose={toggleAddUserModal} onSave={handleSaveUserData}/>
        </Card>
    )
}

export default UserStep
